import type React from 'react'

import type { ThreadListItem } from '../../types'
import css from './styles.module.css'
import { getRepliesLabel } from './utils'

interface Props {
  thread: ThreadListItem
}

export const LinkFooter: React.FC<Props> = ({
  thread: { repliesCount, kind },
}) => (
  <div className={css.link_footer}>
    <span className={css.replies_count}>
      {getRepliesLabel(repliesCount, kind)}
    </span>
  </div>
)
